import React, { useState } from "react";
import PropTypes from "prop-types";
import TariffCardV2 from "../ComponentsUI/TariffCardV2";
import { inject } from "mobx-react";

const TariffCardV2Container = (props) => {
	let {
		ApplicationModel: { text },
		data,
		onClickConnect,
		buttonConnectComponent,
	} = props;
	const [isOpen, setIsOpen] = useState(false);

	const clickHandler = () => {
		setIsOpen((isOpen) => !isOpen);
	};
	return (
		<TariffCardV2
			data={data}
			onClick={clickHandler}
			isOpen={isOpen}
			onClickConnect={onClickConnect}
			buttonConnectComponent={buttonConnectComponent}
			master_text={text.master_now}
			hit_text={text.hit}
			exclusive_text_1={text.first}
			first_month_free_text={text.first_month_free}
			month_text={text.servicesMonth}
			free_text={text.free}
			with_discount_text={text.with_discount}
			discount_to_text={text.discount_to}
			speed_new_text={text.speed_new}
			servicesHomeInternet_text={text.servicesHomeInternet}
			channels_text={text.servicesChannel}
			tv_text={text.TV}
			tv_channels_text={text.TV_channels}
			sim_card_text={text.sim_card}
			gb_text={text.GB}
			min_text={text.min}
			first_month_with_discount_text={text.first_month_with_discount}
			free_to_text={text.free_to}
		/>
	);
};

TariffCardV2Container.propTypes = {
	data: PropTypes.object,
	onClickConnect: PropTypes.func,
	priceMeasure: PropTypes.string,
};

export default inject("ApplicationModel")(TariffCardV2Container);
